import clsx from 'clsx';
import { OpenAPIWebhookExample } from './OpenAPIWebhookExample';
import { OpenAPIColumnSpec } from './common/OpenAPIColumnSpec';
import { OpenAPISummary } from './common/OpenAPISummary';
import { resolveOpenAPIContext } from './context';
/**
 * Display an interactive OpenAPI webhook.
 */
export function OpenAPIWebhook(props) {
    var className = props.className, data = props.data, contextInput = props.context;
    var context = resolveOpenAPIContext(contextInput);
    return (<div className={clsx('openapi-webhook', className)}>
            <OpenAPISummary data={data} context={context}/>
            <div className="openapi-columns">
                <OpenAPIColumnSpec data={data} context={context}/>
                <div className="openapi-column-preview">
                    <div className="openapi-column-preview-body">
                        <OpenAPIWebhookExample data={data} context={context}/>
                    </div>
                </div>
            </div>
        </div>);
}
